type ArLogLevel = 'info' | 'warn' | 'error';

const isVerboseArEnabled = () =>
    (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test')
    || (typeof window !== 'undefined' && new URLSearchParams(window.location.search).get('debug') === '1');

export const logArEvent = (level: ArLogLevel, event: string, payload?: Record<string, unknown>) => {
    if (!isVerboseArEnabled() && level === 'info') {
        return;
    }

    const args: unknown[] = [`[WebAR] ${event}`];
    if (payload) {
        args.push(payload);
    }

    if (level === 'warn') {
        console.warn(...args);
        return;
    }

    if (level === 'error') {
        console.error(...args);
        return;
    }

    console.info(...args);
};
